<template>
  <div class="departments-page">
    <!-- 科室展示页面横幅 -->
    <section class="departments-hero">
      <div class="hero-overlay">
        <div class="hero-content">
          <h1
            v-for="(item, index) in defaultInfos.department_title"
            :key="index"
          >
            {{ item }}
          </h1>
          <p
            v-for="(item, index) in defaultInfos.department_subtitle"
            :key="index"
          >
            {{ item }}
          </p>
        </div>
      </div>
    </section>

    <!-- 科室列表 -->
    <section class="departments-list-section">
      <div class="container">
        <div class="departments-filter">
          <div class="filter-buttons">
            <template v-for="item in filterOptions" :key="item.value">
              <button
                class="filter-btn"
                :class="{ active: selectedFilter === item.value }"
                @click="selectFilter(item.value)"
              >
                {{ item.label }}
              </button>
            </template>
          </div>
        </div>

        <div class="departments-grid" v-if="filterDepartment?.length">
          <div
            class="department-card"
            v-for="dept in filterDepartment"
            :key="dept.id"
          >
            <div class="dept-image">
              <img
                class="service-icon"
                :src="dept.image"
                :alt="dept.name"
                srcset=""
              />
            </div>
            <h3>{{ dept.name }}</h3>
            <p class="dept-description">{{ dept.description }}</p>
            <div class="dept-features">
              <span
                class="feature-tag"
                v-for="feature in dept.features"
                :key="feature.sortOrder"
                >{{ feature.feature }}</span
              >
            </div>
            <div class="dept-info">
              <p><strong>科室主任：</strong>{{ dept.director }}</p>
              <!-- <p><strong>床位数量：</strong>{{ dept.beds }}张</p> -->
              <p v-if="dept.outpatients">
                <strong>年门诊量：</strong>{{ dept.outpatients }}人次
              </p>
            </div>
            <div class="dept-actions">
              <div class="btn-primary" @click="switchToDoctors(dept.category)">
                专家介绍
              </div>
              <button class="btn-outline" @click="showMoreInfo(dept.category)">
                科室详情
              </button>
            </div>
          </div>
        </div>
        <!-- 空状态提示 -->
        <div v-else class="empty-state">
          <div class="empty-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.5 14.25V16.5C19.5 17.3284 18.8284 18 18 18H6C5.17157 18 4.5 17.3284 4.5 16.5V14.25"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 3V6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 18V21"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3 12H6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18 12H21"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3 class="empty-title">暂无科室信息</h3>
        </div>
      </div>
    </section>

    <!-- 科室体系介绍 -->
    <section class="departments-intro">
      <div class="container">
        <div class="intro-content">
          <div class="intro-text">
            <h2
              v-for="(item, index) in defaultInfos.department_sys_title"
              :key="index"
            >
              {{ item }}
            </h2>
            <p
              v-for="(item, index) in defaultInfos.department_sys_subtitle"
              :key="index"
            >
              {{ item }}
            </p>
            <ul>
              <li
                v-for="(item, index) in defaultInfos.department_sys_info"
                :key="index"
              >
                <strong>{{ item.split("|*|")[0] }}</strong
                >{{ item.split("|*|")[1] }}
              </li>
            </ul>
          </div>
          <div class="intro-image">
            <div class="image-placeholder">
              <Carousel />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 重点科室 -->
    <section class="key-departments">
      <div class="container">
        <div class="section-header">
          <h2>重点科室</h2>
          <p>医院拥有多个重点学科和特色专科</p>
        </div>
        <div class="key-depts-grid">
          <div
            class="key-dept-card"
            v-for="keyDept in keyDepartments"
            :key="keyDept.id"
          >
            <div class="key-dept-image">
              <img
                class="service-icon"
                :src="keyDept.image"
                :alt="keyDept.name"
                srcset=""
              />
            </div>
            <h3>{{ keyDept.name }}</h3>
            <p class="key-dept-level">{{ keyDept.level }}</p>
            <p class="key-dept-desc">{{ keyDept.descimp }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 蒙层 -->
    <div class="mask" v-if="showMask" @click="closeMask">
      <div class="mask-content" @click.stop>
        <button class="mask-close" @click="closeMask">x</button>

        <div class="mask-header">
          <img
            :src="currentDeptData?.image"
            :alt="currentDeptData?.name"
            class="dept-detail-icon"
          />
          <div class="header-info">
            <h2>{{ currentDeptData?.name }}</h2>
            <p class="dept-subtitle">
              {{ getGroupName(currentDeptData?.group) }}
            </p>
          </div>
        </div>

        <div class="mask-body">
          <!-- 基本信息卡片 -->
          <!-- <div class="info-card">
            <div class="card-title">
              
              <img src="/指示.png"/>
              <h3>基本信息</h3>
            </div>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">科室主任：</span>
                <span class="value">{{ currentDeptData?.director }}</span>
              </div>
              <div class="info-item">
                <span class="label">床位数量：</span>
                <span class="value">{{ currentDeptData?.beds }} 张</span>
              </div>
              <div class="info-item">
                <span class="label">年门诊量：</span>
                <span class="value"
                  >{{ currentDeptData?.outpatients }} 人次</span
                >
              </div>
            </div>
          </div> -->

          <!-- 科室简介 -->
          <div class="info-card" v-if="currentDeptData?.introduce">
            <div class="card-title">
              <img :src="arrow" alt="asdflkj" />
              <h3>科室简介</h3>
            </div>
            <p class="detail-text">{{ currentDeptData.introduce }}</p>
          </div>

          <!-- 特色技术 -->
          <div class="info-card" v-if="currentDeptData?.features?.length">
            <div class="card-title">
              <img :src="arrow" />
              <h3>诊疗项目</h3>
            </div>
            <div class="features-list">
              <span
                class="feature-item"
                v-for="(feature, index) in currentDeptData?.projects"
                :key="index"
              >
                {{ feature.project }}
              </span>
            </div>
          </div>

          <!-- 成就荣誉 -->
          <div class="info-card" v-if="currentDeptData?.achievements?.length">
            <div class="card-title">
              <img :src="arrow" />
              <h3>成就荣誉</h3>
            </div>
            <div class="achievements-list">
              <div
                class="achievement-item"
                v-for="(achievement, index) in currentDeptData.achievements"
                :key="index"
              >
                <span class="trophy"></span>
                <span>{{ achievement.achievement }}</span>
              </div>
            </div>
          </div>

          <!-- 专业特色 -->
          <div class="info-card" v-if="currentDeptData?.features?.length">
            <div class="card-title">
              <img :src="arrow" />
              <h3>专业特色</h3>
            </div>
            <div class="achievements-list">
              <div
                class="achievement-item"
                v-for="(specialty, index) in currentDeptData.features"
                :key="index"
              >
                <span class="trophy"></span>
                <span>{{ specialty.feature }}</span>
              </div>
            </div>
          </div>

          <!-- 联系方式 -->
          <div class="info-card" v-if="currentDeptData?.contact">
            <div class="card-title">
              <span class="icon">📞</span>
              <h3>联系我们</h3>
            </div>
            <p class="contact-info">{{ currentDeptData.contact }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  useDepartmentsStore,
  type DepartmentType,
} from "@/stores/departments.ts";
import Carousel from "@/components/Carousel/index.vue";
import { useDefaultInfoStore } from "@/stores/defaultInfo.ts";

const arrow = new URL("/Other/arrow.png", import.meta.url).href;
const departments = ref<DepartmentType[]>([]);
const keyDepartments = ref<DepartmentType[]>([]);
const departmentsStore = useDepartmentsStore();
const defaultInfoStore = useDefaultInfoStore();
const defaultInfos = computed(() => defaultInfoStore.getFormateInfo);

const getdata = async () => {
  departments.value = departmentsStore.getDepartmentsList;
  filterDepartment.value = departmentsStore.getDepartmentsList;
  const group = route.params.group as string;
  if (!!group) selectFilter(group);
  keyDepartments.value = departmentsStore.getKeyDepartments;
};
onMounted(async () => {
  await departmentsStore.fetchDepartmentsList();
  getdata();
});

const router = useRouter();
const route = useRoute();

type filtersOptionsType = {
  label: string;
  value: string;
};
const filterOptions = ref<filtersOptionsType[]>([
  { label: "全部", value: "all" },
  { label: "内科系统", value: "internal" },
  { label: "外科系统", value: "surgical" },
  { label: "妇科系统", value: "obgyn" },
  { label: "中医系统", value: "traditional" },
  { label: "眼耳鼻喉系统", value: "Otolaryngology" },
  { label: "门诊科室", value: "emergency" },
  { label: "医技科室", value: "medical" },
]);

const filterDepartment = ref<DepartmentType[]>();

const filterDepartments = (group: string) => {
  router.push(`/departments/${group}`);

  if (group === "all") {
    return departments.value;
  }

  return departments.value.filter((dept) => dept.group === group);
};

const selectedFilter = ref("all");
function selectFilter(value: string) {
  filterDepartment.value = filterDepartments(value);
  selectedFilter.value = value;
}

// 蒙层控制
const showMask = ref(false);
const currentDeptData = ref<DepartmentType | null>(null);

function getGroupName(group?: string): string {
  if (!group) return "";
  return (
    filterOptions.value.find((option) => option.value === group)?.label || group
  );
}

function switchToDoctors(dept: string) {
  const deptMapping: Record<string, string> = {
    outpatient: "emergency",
    laboratory: "medical",
    radiology: "medical",
  };
  const mappedDept = deptMapping[dept] || dept;
  router.push({ name: "Doctors", params: { dept: mappedDept } });
}

function showMoreInfo(dept: string) {
  // 获取科室完整数据
  const deptData = departments.value.find((d) => d.category === dept);
  currentDeptData.value = deptData || null;
  showMask.value = true;
}

function closeMask() {
  showMask.value = false;
  currentDeptData.value = null;
}
</script>

<style scoped>
@import "./index.css";
</style>
